import type { ReactNode } from "react";

export function SettingsPage({
  title,
  description,
  action,
  children,
  fillHeight = false,
}: {
  title: string;
  description: string;
  action?: ReactNode;
  children: ReactNode;
  fillHeight?: boolean;
}) {
  return (
    <div
      className={`min-h-0 min-w-0 flex-1 overflow-y-auto p-5 sm:p-8 ${fillHeight ? "md:overflow-hidden" : ""}`}
    >
      <div
        className={`mx-auto w-full max-w-6xl ${fillHeight ? "md:flex md:h-full md:min-h-0 md:flex-col" : ""}`}
      >
        <header
          className={`mb-6 flex items-end justify-between gap-4 ${fillHeight ? "shrink-0 flex-wrap" : ""}`}
        >
          <div>
            <h2 className="text-3xl font-bold tracking-tight">{title}</h2>
            <p className="mt-2 text-sm text-stone-500">{description}</p>
          </div>
          {action}
        </header>
        {children}
      </div>
    </div>
  );
}
